<template>
    <v-app>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular> <span class="ma-3">Lütfen Bekleyiniz...
            </span>
        </v-overlay>
        <!-- Arka plan resmi -->
        <!-- D:\workspace\FormYonetimSistemiVue\formsistemi\src\assets\drahomir-hugo-posteby-mach-n4y3eiQSIoc-unsplash.jpg -->
        <v-img src="../../assets/drahomir-hugo-posteby-mach-n4y3eiQSIoc-unsplash.jpg" height="100vh" width="100%" cover
            class="fill-height">
            <!-- Ortadaki login kartı -->
            <v-container fluid fill-height class="d-flex justify-center align-center">
                <v-card v-if="IdError" class="pa-6" max-width="600" elevation="8"
                    style="background-color: rgba(255, 255, 255, 0.75);">
                    <v-card-title class="justify-center">
                        <h2 class="font-weight-bold">Uyarı</h2>

                    </v-card-title>
                    <v-card-text>
                        <v-alert type="error">
                            {{ error }}
                        </v-alert>


                    </v-card-text>
                </v-card>

                <v-card v-else class="pa-6" max-width="400" elevation="8"
                    style="background-color: rgba(255, 255, 255, 0.75);">
                    <div class="justify-center text-center">
                        <div>
                            <h2 class="font-weight-bold">{{ formName }}</h2>
                        </div>
                        <div>
                            <h1 class="font-weight-bold">Giriş Ekranı</h1>
                        </div>
                    </div>


                    <v-card-text>

                        <v-form ref="loginForm" v-model="valid" lazy-validation class="w-100" max-width="400">

                            <v-text-field v-model="user.username" label="E-posta" prepend-icon="mdi-email"
                                :rules="emailRules" required></v-text-field>

                            <v-text-field v-model="user.password" label="Şifre" prepend-icon="mdi-lock"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword" :rules="passwordRules"
                                required></v-text-field>
                            <v-list-item>
                                <v-list-item-content>

                                    <v-container>
                                        <v-row>
                                            <v-col xs="12" sm="12" md="12" lg="8" xl="8" class="mx-0">
                                                <table>
                                                    <tr>
                                                        <td> </td>
                                                        <td>Güvenlik Kodu:<img :src="captcha.image"
                                                                style="width: 100px; height: 40px;" alt="Captcha" />
                                                        </td>
                                                        <td>
                                                            <v-btn icon class="" fab dark color="teal"
                                                                @click="loadCaptcha"><v-icon>mdi-refresh</v-icon></v-btn>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-col>




                                            <v-col xs="12" sm="12" md="12" lg="4" xl="4" class="mx-0">
                                                <v-text-field :rules="captchaRules" label="Güvenlik Kodu"
                                                    v-model="userInputCaptha"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-container>






                                </v-list-item-content>
                            </v-list-item>
                        </v-form>



                    </v-card-text>

                    <v-card-actions class="d-flex flex-column">
                        <v-btn color="primary" block dark @click="submit" :disabled="!valid">
                            Giriş Yap
                        </v-btn>
                        <!-- <v-btn text small color="grey" class="mt-2">
                            Şifremi Unuttum
                        </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-container>
        </v-img>
    </v-app>
</template>

<script>
import LoginService from '@/services/LoginService';

import router from '@/router';
import axios from 'axios';

import FormService from '@/services/FormService';

export default {
    name: "KullaniciLogin",
    data() {
        return {
            valid: false,
            error: " Bu ID'li bir form bulunamadı.",
            IdError: false,
            formName: "",
            captcha: null,
            userInputCaptha: null,
            overlay: true,
            username: "",
            password: "",
            user: { username: process.env.VUE_APP_USERNAME, password: process.env.VUE_APP_USERPASSWORD, tip: "kullanici" },


            showPassword: false,

            emailRules: [
                v => !!v || 'E-posta gerekli',
                v => /.+@.+\..+/.test(v) || 'Geçerli bir e-posta girin',
            ],
            passwordRules: [
                v => !!v || 'Şifre gerekli',
                v => v.length >= 6 || 'Şifre en az 6 karakter olmalı',
            ],
            captchaRules: [
                v => !!v || 'Bu alan noş bırakılamaz.',

            ],
        };
    },
    created() {
        // this.validate()

        this.loadCaptcha();
        FormService.GetFormName(this.$route.params.id).then((result) => {
            this.formName = result.data;
        }).catch((err) => {
            this.IdError = true;
            this.error = err.response.data;
            //this.$toast.warning(err.response.data);
        }).finally(() => {
            this.overlay = false;
        });
    },
    computed: {


    },
    methods: {


        login() {
            alert(`Kullanıcı: ${this.username}, Şifre: ${this.password}`);
        },
        loadCaptcha() {


            axios.get(process.env.VUE_APP_APIURL + '/api/captcha/generate', {
                withCredentials: true, // session için gerekli

            }
            ).then((result) => {
                console.log("loadCaptcha", result);
                this.captcha = result.data;
                // this.$toast.success("Başarılı bir şekilde kaydedilmiştir.")
            }).catch((err) => {
                this.$toast.warning(err)
            });





        },
        submit() {

            console.log("object", this.$route.params.id);


            if (this.$refs.loginForm.validate()) {




                this.overlay = true;
                //this.$route.push("formlar");
                this.user.formId = this.$route.params.id;
                this.overlay = true;
                LoginService.kullaniciLogin(this.user, this.userInputCaptha,this.captcha.id).then((result) => {
          

                    router.push("/kullaniciDashboard/" + this.$route.params.id)
                    // router.push(result.data.defaultMenu);

                }).catch((err) => {
                
                        this.loadCaptcha();
                    console.log("Err", err);
                    if (err && err.response) {
                        this.$toast.warning(err.response.data)
                    }
                    else {
                        this.$toast.warning("Sunucu ile bağlantı sorunu bulunmaktadır.Lütfen tekrar deneyiniz.")
                    }

                }) .finally(() => {
                
    // Başarıdan veya hatadan bağımsız olarak HER ZAMAN çalışır
        this.overlay = false;
  });


            }
        },

    },
};
</script>

<style>
html,
body,
#app {
    height: 100%;
    margin: 0;
}
</style>
